// modules
import { useOutlet, useLocation } from "react-router-dom";

// components
import HeaderStatusInfo, { Background } from "components/molecules/HeaderStatusInfo/HeaderStatusInfo";
import ExpandedRowTable from "components/atoms/ExpandedRowTable/ExpandedRowTable";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import { Head } from "components/molecules/Head/Head";
import CollapsibleTable from "components/atoms/CollapsibleTable/CollapsibleTable";
import Spinner from "components/atoms/Spinner/Spinner";

// hook
import { useReimbursementVerification } from "containers/ReimbursementVerification/useReimbursementVerification";

// styles
import styles from "containers/ReimbursementVerification/reimbursementVerification.module.css";

// Constants
import { REIMBURSMENT_DECL_VERIFICATION as Constants, Routes } from "constants/global";

export type StatusBarInfoProps = {
	message: React.ReactNode;
	background: Background;
};

export const pageTitle: { [key: string]: string } = {
	[Routes.DECLARATION_VERIFICATION]: Constants.DECL_VERIFICATION_PAGE_TITLE,
	[Routes.DECLARATION_APPROVAL]: Constants.DECL_APPROVAL_PAGE_TITLE
};

const ReimbursementVerification = () => {
	const childRouteElement = useOutlet();
	const { pathname } = useLocation();
	const componentProps = useReimbursementVerification({ pathname });
	const { getGroupHeader, generateCols, handleExpandRows, loadingVouchers, currentExpandedGroup, updatedReimbGroupList, statusBarInfo, defaultGroupKey, columnHeaderData } =
		componentProps;

	if (loadingVouchers) {
		return <Spinner />;
	}

	return (
		<div>
			<Head>{`${pageTitle[pathname]} - Atlas`}</Head>
			{!childRouteElement && (
				<div className="relative">
					<div className={styles?.root}>
						<HeaderStatusInfo message={statusBarInfo.message} background={statusBarInfo.background} />
						<PageTitle showBackIcon={false} title={pageTitle[pathname]} subTitle={Constants.PAGE_SUBTITLE} />
					</div>
					{!loadingVouchers &&
						updatedReimbGroupList &&
						updatedReimbGroupList.map((groupItem, index) => {
							return (
								<div className={styles.table_container} key={groupItem.voucher_group_code}>
									<CollapsibleTable
										defaultExpandedGroupKey={defaultGroupKey}
										keyIndex={index}
										handleExpandRows={handleExpandRows}
										currentExpandedGroup={currentExpandedGroup}
										rowClassName="collapsible-table"
										showHeader={false}
										generateCols={generateCols}
										groupItem={[groupItem]}
										generateData={getGroupHeader}
										expandedRowElement={() => (
											<ExpandedRowTable groupDetails={groupItem} columnHeaderData={columnHeaderData[pathname]} rowsPerPage={Constants.DEFAULT_ROW_PER_PAGE} />
										)}
									/>
								</div>
							);
						})}
				</div>
			)}
			{childRouteElement}
		</div>
	);
};

export default ReimbursementVerification;
